var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 49,
    rx: 12,
    fill: "#F0F0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 48,
    rx: 11.5,
    stroke: "black",
    strokeOpacity: 0.21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7071 37.7091C24.3166 38.0985 23.6834 38.0968 23.2929 37.7051L16.929 31.3235C16.5384 30.9319 16.5384 30.2987 16.929 29.9093C17.3195 29.5199 17.9526 29.5216 18.3432 29.9132L24 35.5858L29.6568 29.9446C30.0474 29.5552 30.6805 29.557 31.071 29.9486C31.4616 30.3402 31.4616 30.9733 31.071 31.3628L24.7071 37.7091ZM24 28L25 28.0028L25 37.0028L24 37L23 36.9972L23 27.9972L24 28Z",
    fill: "#8D8888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2929 13.2909C23.6834 12.9015 24.3166 12.9032 24.7071 13.2949L31.071 19.6765C31.4616 20.0681 31.4616 20.7013 31.071 21.0907C30.6805 21.4801 30.0474 21.4784 29.6568 21.0868L24 15.4142L18.3432 21.0554C17.9526 21.4448 17.3195 21.443 16.929 21.0514C16.5384 20.6598 16.5384 20.0267 16.929 19.6372L23.2929 13.2909ZM24 23L23 22.9972L23 13.9972L24 14L25 14.0028L25 23.0028L24 23Z",
    fill: "#8D8888"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag-icon.424413c23663abf00764b39b96ab3140.svg";
export { ForwardRef as ReactComponent };